import { render, staticRenderFns } from "./BalanceList.vue?vue&type=template&id=08b0ed0e&scoped=true"
import script from "./BalanceList.vue?vue&type=script&lang=js"
export * from "./BalanceList.vue?vue&type=script&lang=js"
import style0 from "./BalanceList.vue?vue&type=style&index=0&id=08b0ed0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0ed0e",
  null
  
)

export default component.exports